<template>
    <div class="flex flex-col gap-4">
        <h1 class="text-xl leading-none">
            {{ $t('cart.resetCart.title') }}
        </h1>
        <div class="flex flex-col gap-2">
            <p class="text-base">
                {{ $t('cart.resetCart.text') }}
            </p>
        </div>
    </div>
</template>
